import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cancelBy: "",
    isLoading: false
};

const cancelRideSlice = createSlice({
    name: "cancelRide",
    initialState,
    reducers: {
        setCancelRideData: (state, action) => {
            state.cancelBy = action.payload;
            state.isLoading = true
        },

        setCancelRideLoading: (state) => {
            state.isLoading = false;
            state.cancelBy = ""
        },
    },
});

export const {
    setCancelRideData,
    setCancelRideLoading,
    setLoading,
} = cancelRideSlice.actions;
export const selectCandelRideData = (state) => state.cancelRide.cancelBy;

export const selectCandelRideLoading = (state) => state.cancelRide.isLoading;

export default cancelRideSlice.reducer;